import { assetUrl } from 'src/single-spa/asset-url';
import { Component, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';
import { MasterSlot, ShopMaxPerDay, Slot, SlotsPerDay } from '../../../shared/models/slot-management.model';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DateTime } from 'luxon';
import { TranslateService } from '@ngx-translate/core';
import { days, Department, ITeam } from '@signal/asp-data-commons';
import { titleCase, unsubscribeSubscriptions } from '../../services/util.service';
import _ from 'lodash'
import { SubscriptionList } from '../../models/asp.types';
import { Store } from '@ngrx/store';
import { SettingsState } from '../../../store/settings/settings.reducer';
import * as fromSettingsSelectors from '../../../store/settings/settings.selectors';

@Component({
  selector: 'app-timeslot-grid',
  templateUrl: './timeslot-grid.component.html',
  styleUrls: ['./timeslot-grid.component.scss']
})
export class TimeslotGridComponent implements OnInit, OnDestroy, OnChanges{
  private slotIntervalInMinutes = 15;
  @Input() slotDetails$: SlotsPerDay[];
  @Input() viewMode: string;
  @Input() team: ITeam;
  @Input() maxAndMasterSlots$: { max: any, masterSlot: MasterSlot[] };
  @Output() saveChanges: EventEmitter<any> = new EventEmitter();
  @Input() switchInput:boolean;
  @Output() formEdited:EventEmitter<boolean> = new EventEmitter();
  @Input() saveClicked:boolean;
  @Input() cancleClicked:boolean
  @Output() cancleClick:EventEmitter<boolean> = new EventEmitter();
  @Input() department: string = '';
  isFormEdited:boolean=false;
  subscriptions: SubscriptionList = {};
  shopMaxDetails: ShopMaxPerDay[];
  shopMaxSlots: UntypedFormGroup;
  slotTotals = {};
  slotTotalStatus = {};
  lastValue:any

  //team slots save button
  isSaveClicked: boolean;

  constructor(private readonly formBuilder: UntypedFormBuilder,
    private readonly translate: TranslateService,
    private readonly settingsState: Store<SettingsState>) {
      this.shopMaxSlots = this.formBuilder.group({
        slotsPerDay: this.formBuilder.array([])
      });
  }

  ngOnInit() {
    this.subscriptions.slotDuration = this.settingsState.select(fromSettingsSelectors.time).subscribe(time => {
      const configuredSlotInterval = Number(time?.slotDuration);
      if (!isNaN(configuredSlotInterval) && configuredSlotInterval > 0) {
        this.slotIntervalInMinutes = configuredSlotInterval;
      }
    });

      this.subscriptions.form = this.shopMaxSlots.valueChanges.subscribe(value => {
      
      this.calculateTotal(value.slotsPerDay);
      
      this.formEdited.emit(this.shopMaxSlots.dirty)

      if(this.viewMode ==='Team' && this.shopMaxSlots.dirty)
      {
        this.isSaveClicked=true
      }
    })
    //this.slots.updateValueAndValidity();
  }

  get daysOfWeek() {
    return days;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty('maxAndMasterSlots$')) {
      if (this.maxAndMasterSlots$ && this.maxAndMasterSlots$.max.length) {
        this.shopMaxDetails = this.maxAndMasterSlots$.max;
        this.calculateTotal(this.slots.value);
      }
    }

    if (changes.hasOwnProperty('slotDetails$') && _.isEqual(this.slots.value,[])) {
      this.setArrayValue(this.slots, this.slotDetails$);
    }
   
    if(this.saveClicked && this.shopMaxSlots.dirty)
    {
      this.onSave();
    }
    if(this.cancleClicked && this.shopMaxSlots.dirty)
    {
        this.onCancel();
    }
  
   }

  calculateTotal(slots: SlotsPerDay[]) {
    if (slots && slots.length && this.maxAndMasterSlots$?.max?.length) {
      this.slotTotals = [];
      slots.forEach((data: SlotsPerDay) => {
        let total = 0;
        const slotCapacity = this.viewMode === 'Team' ?
          this.maxAndMasterSlots$.max.find(x => x.dayOfWeek === data.dayOfWeek)?.capacities.find(y => y.id == this.team.id)?.capacity :
          this.maxAndMasterSlots$.max.find(x => x.dayOfWeek === data.dayOfWeek)?.slotCapacity;
        data.slots.forEach((slot: Slot) => {
          total += this.checkIfMasterSlot(this.maxAndMasterSlots$.masterSlot, slot.slotId) ? (slot.slotValue || 0) : 0;
        });
        const perDayTotal = total + '/' + (slotCapacity || 0);
        this.slotTotals[data.dayOfWeek] = perDayTotal;
        this.slotTotalStatus[data.dayOfWeek] = this.department === Department.SERVICE ? assetUrl('icons/capacity-indicators/' +
         this.getCapacityIndicator(slotCapacity || 0, total) + '.svg') : (total === 0 || total > slotCapacity) ? 
        assetUrl('icons/capacity-indicators/full-capacity.svg') : '';
      })
    }
  }

  checkIfMasterSlot(masterSlots, slotId) {
    return masterSlots && !!masterSlots.find(x => x.slotId == slotId);
  }

  getCapacityIndicator(slotCapacity, total) {
    return total === slotCapacity ? 'low-capacity' : (total === 0 || total > slotCapacity) ?
      'full-capacity' : 'half-capacity';
  }

  setArrayValue(formArray: UntypedFormArray, slots: SlotsPerDay[]) {
    let masterSlots = [];
    masterSlots = this.maxAndMasterSlots$?.masterSlot;
    if (slots && slots.length && masterSlots && masterSlots.length) {
      formArray.clear();
      slots.forEach((data: SlotsPerDay) => {
        const slotArray = [];
        masterSlots.forEach(slotIdVal => {
          if (data?.slots?.map(x => x.slotId).includes(slotIdVal.slotId)) {
            const slot: Slot = data.slots.find(x => x.slotId === slotIdVal.slotId);
            slotArray.push(new UntypedFormGroup({
              slotId: new UntypedFormControl(slot.slotId),
              slotValue: new UntypedFormControl(slot.slotValue),
            }));
          } else {
            slotArray.push(new UntypedFormGroup({
              slotId: new UntypedFormControl(slotIdVal.slotId),
              slotValue: new UntypedFormControl(null),
            }));
          }
        });
        formArray.push(new UntypedFormGroup({
          dayOfWeek: new UntypedFormControl(data.dayOfWeek),
          slots: new UntypedFormArray(slotArray)
        }));
      })
    }
  }

  patchArrayValue(formArray: UntypedFormArray, slots: SlotsPerDay[]) {
    if (slots && slots.length) {
      slots.forEach((data: SlotsPerDay, i) => {
        const slotArray = (formArray.controls[i] as UntypedFormGroup)?.controls.slots as UntypedFormArray;
        data.slots.forEach((slot: Slot, j) => {
          (slotArray.controls[j] as UntypedFormGroup).controls.slotValue.patchValue(slot.slotValue);
        });
      })
    }

  }

  get slots() {
    return this.shopMaxSlots.controls.slotsPerDay as UntypedFormArray;
  }

  dayIndex(day) {
    return this.slots.value.findIndex(x => x.dayOfWeek === day);
  }

  timeIndex(day, slot) {
    const slots = this.slots.value.find(x => x.dayOfWeek === day)?.slots;
    return slots?.findIndex(x => x.slotId === slot.slotId);
  }

  checkIfValidSlot(day, slot) {
    const dayMaxDetail = this.shopMaxDetails?.find(x => x.dayOfWeek === day);
    if (!dayMaxDetail) {
      return true;
    }
    const hoursOfOperation = dayMaxDetail.hoursOfOperation;
    if (hoursOfOperation === 'Closed') {
      return true;
    } else {
      const timeSplit = hoursOfOperation.split(' - ');
      const slotTime = DateTime.fromFormat(slot.slotId, 'h:mm a');
      const startTime = DateTime.fromFormat(timeSplit[0], 'h:mm a');
      const endTime = DateTime.fromFormat(timeSplit[1], 'h:mm a');

      if (!slotTime.isValid || !startTime.isValid || !endTime.isValid) {
        return true;
      }

      const isOutsideHours = !(slotTime >= startTime && slotTime <= endTime);
      if (isOutsideHours) {
        return true;
      }

      const diffFromStart = slotTime.diff(startTime, 'minutes').minutes;
      return diffFromStart % this.slotIntervalInMinutes !== 0;
    }
  }
  getWeekDays(day)
  {
    return this.translate.instant(`common.${titleCase(day)}`)
  }


  onSave() {
    if (this.viewMode === 'Team') {
      this.isSaveClicked=false;
      this.saveChanges.emit(this.slots.value);
      
    }else{
      this.saveChanges.emit(this.slots.value);
      this.formEdited.emit(false)
    }
    this.shopMaxSlots.markAsPristine();
  }

  onCancel() {
    if (this.viewMode === 'Team') {
      
      this.patchArrayValue(this.slots, this.slotDetails$);
      this.isSaveClicked=false
    }
    else{
      this.patchArrayValue(this.slots, this.slotDetails$);
      this.cancleClick.emit(false)
    }
    this.shopMaxSlots.markAsPristine();
  }

  reset(){
    this.slots.clear();
    this.maxAndMasterSlots$ = { max: null, masterSlot: [] };
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subscriptions);
    this.reset();
  }

}
